import type { Components, Theme } from "@mui/material";

export const MuiAppBar: Components<Theme>["MuiAppBar"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				alignItems: "center",
				backgroundColor: "var(--mui-palette-muted-main)",
				borderColor: "var(--mui-palette-border)",
				borderStyle: "solid",
				borderWidth: 0,
				boxShadow: "none",
				flexDirection: "row",
				gap: theme.spacing(1),
				height: theme.spacing(7),
				paddingInline: theme.spacing(2),
				top: "auto",
			}),
		},
	],
};
